import { render, staticRenderFns } from "./InvRL2.vue?vue&type=template&id=e56c2cc0"
import script from "./InvRL2.vue?vue&type=script&lang=js"
export * from "./InvRL2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports